const modalCategories = Object.freeze({
  GENERAL_SECTION__GRID: 1,
  GENERAL_SECTION__WIDGETLIST: 2,
  REPORTS_SECTION: 3,
  ROLE_SECTION: 4,
  FOOTER_SECTION: 5,
});

export default modalCategories;
